import React from 'react';
import { useTranslation } from 'react-i18next';
import logger from '../../utils/logger';

type EnhancedLogger = typeof logger & { isProduction?: boolean };

const EnvironmentInfo: React.FC = () => {
  const { t, ready } = useTranslation('common');
  
  // Diese Komponente nutzen, um zu testen, ob wir im Produktionsmodus sind
  const isProduction = 
    process.env.NODE_ENV === 'production' || 
    (logger as EnhancedLogger).isProduction || 
    window.location.hostname !== 'localhost';

  // Im Produktionsmodus wird diese Komponente gar nicht gerendert
  if (isProduction) {
    return null;
  }

  // Warten bis i18next bereit ist
  if (!ready) {
    return null;
  }

  return (
    <div className="fixed bottom-0 right-0 bg-yellow-100 border border-yellow-300 text-yellow-800 p-2 m-2 text-xs rounded shadow-lg z-50">
      <h3 className="font-bold">{t('debugEnvironmentInfo')}</h3>
      <ul className="mt-1">
        <li>NODE_ENV: <code>{process.env.NODE_ENV}</code></li>
        <li>Logger.isProduction: <code>{String((logger as EnhancedLogger).isProduction)}</code></li>
        <li>Hostname: <code>{window.location.hostname}</code></li>
        <li>Pino Level: <code>{(logger as any).level}</code></li>
      </ul>
      <p className="mt-1 text-xs">
        <em>{t('developmentOnlyMessage')}</em>
      </p>
    </div>
  );
};

export default EnvironmentInfo; 